/**
 * Recharge Subscription Widget - Shadow DOM Styles
 */

(function() {
  // CSS variables from Custom example
  const CSS_VARS = `
    --white: #ffffff;
    --blue-98: #F6F9FE;
    --dark-navy-10: #003057;
    --dark-navy-30: #4d6e89;
    --dark-navy-90: #cbd3d9;
    --text-title-7: 1rem;
    --text-ui-3: 0.9375rem;
    --text-ui-5: 0.75rem;
    --body-1: 1.125rem;
    --pill: 0.75rem;
  `;

  // Styles for main Shadow DOM
  const STYLES = `
    /* ========== CUSTOM STYLES FOR MAIN SHADOW DOM ========== */
    
    :host {
      ${CSS_VARS}
    }
    
    /* Font for all elements */
    :host, * {
      font-family: 'Inter', sans-serif !important;
    }

    /* Widget root */
    .rc-widget__root {
      width: 100%;
    }

    /* Purchase options container */
    .rc-selection__root,
    .rc-content-wrap {
      display: flex !important;
      flex-direction: column !important;
      gap: 8px !important;
    }

    /* Common card styles */
    .rc-purchase-option {
      position: relative !important;
      border-radius: 6px !important;
      overflow: visible !important;
      transition: all 0.2s ease;
      margin-top: 0 !important;
    }

    /* Subscription option */
    .rc-purchase-option__subscription {
      border: 1px solid var(--dark-navy-10, #003057) !important;
      margin-top: 14px !important;
      padding: 20px 0 12px 12px !important;
    }

    .rc-purchase-option:not(:last-child) {
      margin-bottom: 0 !important;
    }

    .rc-selection__root div[rc-not-selected].rc-purchase-option {
      border-color: #e5e7eb !important;
    }

    /* One-time option */
    .rc-purchase-option__onetime {
      background-color: var(--white, #FFFFFF) !important;
      border: 1px solid var(--dark-navy-90, #cbd3d9) !important;
      padding: 12px !important;
    }

    /* Badge - positioned above card */
    .rc-purchase-option__badge {
      display: inline-block !important;
      position: absolute !important;
      top: -14px !important;
      left: 10px !important;
      right: auto !important;
      width: auto !important;
      max-width: fit-content !important;
      background-color: #0f4492 !important;
      color: var(--white, #FFFFFF) !important;
      border-radius: 6px !important;
      border: 1px solid #0f4492 !important;
      font-size: 11px !important;
      padding: 4px 12px !important;
      font-weight: 400 !important;
      z-index: 10 !important;
      line-height: 1.42 !important;
      white-space: nowrap !important;
    }

    @media (min-width: 48rem) {
      .rc-purchase-option__badge {
        font-size: 13px !important;
      }
    }

    /* Label - horizontal layout */
    .rc-purchase-option__label {
      display: flex !important;
      flex-direction: row !important;
      align-items: flex-start !important;
      justify-content: space-between !important;
      width:auto !important;
      gap: 8px !important;
    }

    .rc-purchase-option__label.rc-dynamic-pricing {
      padding-top: 0 !important;
      padding-left: 10px !important;
    }

    .compact [rc-not-selected] .rc-purchase-option__label.rc-dynamic-pricing
    {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    .compact [rc-not-selected] .rc-purchase-option__label
    {
      padding: 12px 20px;
    }
    .compact .rc-purchase-option__label
    {
      padding: 12px 20px;
    }

    /* Selector (radio + text) */
    .rc-purchase-option__selector {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      flex: 1 !important;
    }

    /* Selector text - title */
    .rc-purchase-option__selector span,
    .rc-purchase-option__selector_subscription,
    .rc-purchase-option__selector_onetime {
      font-family: 'Inter', sans-serif !important;
      font-weight: 500 !important;
      color: var(--dark-navy-10, #003057) !important;
      font-size: 15px !important;
      line-height: 1.1 !important;
    }

    @media (min-width: 48rem) {
      .rc-purchase-option__selector span,
      .rc-purchase-option__selector_subscription,
      .rc-purchase-option__selector_onetime {
        font-size: 16px !important;
      }
    }

    /* One-time selector text - muted color */
    .rc-purchase-option__onetime .rc-purchase-option__selector span,
    .rc-purchase-option__onetime .rc-purchase-option__selector_onetime {
      color: var(--dark-navy-30, #4d6e89) !important;
    }

    /* Prices container - vertical stack */
    .rc-purchase-option__prices {
      display: flex !important;
      flex-direction: row !important;
      align-items: baseline !important;
      justify-content: flex-end !important;
      gap: 4px !important;
      flex-shrink: 0 !important;
      margin-left: auto !important;
    }

    /* Original price - strikethrough */
    .rc-price.strike-through,
    .rc-purchase-option__original-price {
      color: var(--dark-navy-30, #4d6e89) !important;
      opacity: 0.5 !important;
      font-size: 15px !important;
      text-decoration: line-through !important;
      font-weight: 400 !important;
      line-height: 1.1 !important;
    }

    .compact .rc-purchase-option__selector rc-learn-more
    {
      margin-left: -6px !important;
    }
    
    div[rc-not-selected] .rc-price.strike-through {
      opacity: 0 !important;
    }

    /* Sale/discounted price */
    .rc-purchase-option__discounted-price,
    .rc-purchase-option__prices .rc-price:not(.strike-through):not(.text-muted) {
      color: var(--dark-navy-10, #003057) !important;
      font-weight: 500 !important;
      font-size: 15px !important;
      line-height: 1.1 !important;
    }

    @media (min-width: 48rem) {
      .rc-purchase-option__discounted-price,
      .rc-purchase-option__prices .rc-price:not(.strike-through):not(.text-muted) {
        font-size: 16px !important;
      }
    }

    /* One-time price */
    .rc-purchase-option__onetime .rc-price,
    .rc-purchase-option__price {
      color: var(--dark-navy-30, #4d6e89) !important;
      font-weight: 500 !important;
      font-size: 15px !important;
      line-height: 1.1 !important;
    }

    /* Unit price wrapper - wraps prices + unit price */
    .rc-prices-wrapper {
      display: flex !important;
      flex-direction: column !important;
      align-items: flex-end !important;
      gap: 2px !important;
      flex-shrink: 0 !important;
      margin-left: auto !important;
    }

    /* When we have wrapper, prices don't need margin-left */
    .rc-prices-wrapper .rc-purchase-option__prices {
      margin-left: 0 !important;
    }

    /* Unit price styling */
    .rc-unit-price {
      font-family: 'Inter', sans-serif !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      color: var(--dark-navy-30, #4d6e89) !important;
      line-height: 1.2 !important;
      overflow: hidden !important;
      transition: max-height 0.2s ease, opacity 0.2s ease !important;
      max-height: 0 !important;
      opacity: 0 !important;
    }

    /* Always show unit price in subscription option */
    .rc-purchase-option__subscription .rc-unit-price {
      max-height: 20px !important;
      opacity: 1 !important;
    }

    /* Show unit price in one-time option only when selected */
    .rc-purchase-option__onetime[rc-selected] .rc-unit-price,
    .rc-selection__onetime[rc-selected] .rc-unit-price {
      max-height: 20px !important;
      opacity: 1 !important;
    }

    /* Hide original rc-benefits */
    #rc-benefits,
    rc-benefits {
      display: none !important;
      visibility: hidden !important;
      height: 0 !important;
      max-height: 0 !important;
      min-height: 0 !important;
      overflow: hidden !important;
      padding: 0 !important;
      margin: 0 !important;
      border: 0 !important;
      position: absolute !important;
      pointer-events: none !important;
    }

    /* Hide original sub-container */
    .rc-purchase-option__sub-container:not(.rc-benefits-permanent) {
      display: none !important;
      visibility: hidden !important;
      height: 0 !important;
      max-height: 0 !important;
      min-height: 0 !important;
      overflow: hidden !important;
      padding: 0 !important;
      margin: 0 !important;
      border: 0 !important;
      position: absolute !important;
      pointer-events: none !important;
    }

    /* Our permanent container is always visible */
    .rc-purchase-option__sub-container.rc-benefits-permanent {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      height: auto !important;
      margin-top: 4px !important;
      padding-left: 0 !important;
      padding-bottom: 0 !important;
      position: relative !important;
    }

    /* Hide selling plans dropdown */
    rc-selling-plans,
    .rc-plans-button-group {
      display: none !important;
    }

    /* Radio button styling - custom checkbox */
    rc-radio-icon {
      flex-shrink: 0 !important;
      margin-top: 1px !important;
      width: 14px !important;
      height: 14px !important;
    }

    rc-radio-icon svg {
      display: none !important;
    }

    /* Custom checkbox circle */
    rc-radio-icon {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      border-radius: 50% !important;
      background-color: var(--white, #FFFFFF) !important;
      border: 1px solid var(--dark-navy-90, #cbd3d9) !important;
    }

    /* Selected state - filled with checkmark */
    rc-radio-icon[rc-selected="true"],
    .rc-purchase-option[rc-selected] rc-radio-icon,
    .rc-purchase-option__subscription[rc-selected] rc-radio-icon {
      background-color: var(--dark-navy-10, #003057) !important;
      border-color: var(--dark-navy-10, #003057) !important;
    }

    .rc-purchase-option[rc-selected] {
      background-color: var(--blue-98, #F6F9FE) !important;
    }

    @media (min-width: 80rem) {
      rc-radio-icon {
        width: 16px !important;
        height: 16px !important;
      }
    }

    /* ====================================================== */
  `;

  // SVG checkmark from Custom
  const CHECKMARK_SVG = `<svg width="10" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.5 3.69231L4.02632 6L9.5 1" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg>`;

  // Styles for nested Shadow DOM (rc-benefits)
  const BENEFITS_STYLES = `
    /* ========== CUSTOM STYLES FOR RC-BENEFITS SHADOW DOM ========== */
    
    :host {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      height: auto !important;
      max-height: none !important;
    }
    
    :host, * {
      font-family: 'Inter', sans-serif !important;
    }

    .rc-benefits__list {
      padding-left: 0 !important;
      margin: 0 !important;
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
    }
    
    .rc-benefits__list p {
      font-family: 'Inter', sans-serif !important;
      margin: 0 !important;
      padding: 0 !important;
      color: #4d6e89 !important;
      font-weight: 400 !important;
      line-height: 1.42 !important;
      font-size: 11px !important;
      padding-left:22px !important;
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
    }

    @media (min-width: 48rem) {
      .rc-benefits__list p {
        font-size: 13px !important;
      }
    }
    
    /* ====================================================== */
  `;

  function injectStyles(shadowRoot, id, styles) {
    if (shadowRoot.querySelector('#' + id)) return;
    
    const style = document.createElement('style');
    style.id = id;
    style.textContent = styles;
    shadowRoot.appendChild(style);
    console.log('[RC] ✅ Styles injected: ' + id);
  }

  // Styles for rc-radio-icon Shadow DOM
  const RADIO_ICON_STYLES = `
    /* Custom checkmark instead of radio button */
    :host {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 14px !important;
      height: 14px !important;
      border-radius: 50% !important;
      background-color: #FFFFFF !important;
      border: 1px solid #cbd3d9 !important;
      flex-shrink: 0 !important;
      position: relative !important;
    }
    
    /* Selected state - dark background */
    :host([checked]) {
      background-color: #003057 !important;
      border-color: #003057 !important;
    }
    
    /* Hide standard icon */
    svg.rc-checked-icon {
      display: none !important;
    }
    
    /* Checkmark visible only when selected */
    .custom-checkmark-wrapper {
      opacity: 0;
    }
    
    :host([checked]) .custom-checkmark-wrapper {
      opacity: 1;
    }
    
    @media (min-width: 80rem) {
      :host {
        width: 16px !important;
        height: 16px !important;
      }
    }
  `;

  function replaceRadioIcons(shadowRoot) {
    const radioIcons = shadowRoot.querySelectorAll('rc-radio-icon');
    
    radioIcons.forEach(icon => {
      // If rc-radio-icon has its own shadow root
      if (icon.shadowRoot) {
        // Inject styles into radio icon shadow root
        injectStyles(icon.shadowRoot, 'rc-radio-custom-styles', RADIO_ICON_STYLES);
        
        // Check if checkmark already added
        if (icon.shadowRoot.querySelector('.custom-checkmark-wrapper')) return;
        
        // Add checkmark as new element
        const checkWrapper = document.createElement('div');
        checkWrapper.className = 'custom-checkmark-wrapper';
        checkWrapper.style.cssText = 'display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; position: absolute; top: 0; left: 0;';
        checkWrapper.innerHTML = CHECKMARK_SVG;
        
        icon.shadowRoot.appendChild(checkWrapper);
        console.log('[RC] ✅ Checkmark added to radio icon');
      }
    });
  }

  // Store cloned benefits content
  let benefitsText = null;
  let permanentCreated = false;

  function preserveBenefitsContent(shadowRoot) {
    // Find subscription option
    const subscriptionOption = shadowRoot.querySelector('.rc-purchase-option__subscription');
    if (!subscriptionOption) return;

    // Find rc-benefits and save its text (only once)
    if (!benefitsText) {
      const rcBenefits = shadowRoot.querySelector('#rc-benefits');
      if (rcBenefits && rcBenefits.shadowRoot) {
        const benefitsParagraph = rcBenefits.shadowRoot.querySelector('.rc-benefits__list p');
        if (benefitsParagraph) {
          benefitsText = benefitsParagraph.textContent;
          console.log('[RC] ✅ Benefits text saved:', benefitsText);
        }
      }
    }

    // Hide ALL original sub-containers (except our permanent)
    const allSubContainers = subscriptionOption.querySelectorAll('.rc-purchase-option__sub-container');
    allSubContainers.forEach(container => {
      if (!container.classList.contains('rc-benefits-permanent')) {
        container.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important;';
      }
    });

    // Hide rc-benefits
    const allRcBenefits = shadowRoot.querySelectorAll('#rc-benefits, rc-benefits');
    allRcBenefits.forEach(el => {
      el.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important;';
    });

    // Create our permanent container only once
    if (!permanentCreated && benefitsText) {
      const existingPermanent = subscriptionOption.querySelector('.rc-benefits-permanent');
      if (!existingPermanent) {
        const label = subscriptionOption.querySelector('.rc-purchase-option__label');
        if (label) {
          const permanentContainer = document.createElement('div');
          permanentContainer.className = 'rc-purchase-option__sub-container rc-benefits-permanent';
          permanentContainer.style.cssText = 'display: block !important; visibility: visible !important;';
          permanentContainer.innerHTML = `<p style="font-family: 'Inter', sans-serif; margin: 0; padding: 0; color: #4d6e89; font-weight: 400; line-height: 1.42; font-size: 13px; padding-left: 43px;">${benefitsText}</p>`;
          
          label.parentNode.insertBefore(permanentContainer, label.nextSibling);
          permanentCreated = true;
          console.log('[RC] ✅ Permanent benefits created');
        }
      } else {
        permanentCreated = true;
      }
    }
  }

  function addHeading() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget) return;
    
    // Find widget container
    const container = widget.closest('.shopify-block') || widget.parentElement;
    if (!container) return;
    
    // Check if heading already added
    if (container.querySelector('.rc-custom-heading')) return;
    
    // Create heading
    const heading = document.createElement('h3');
    heading.className = 'rc-custom-heading';
    heading.textContent = 'Purchase Options';
    
    // Insert at the beginning of container
    container.insertBefore(heading, container.firstChild);
    console.log('[RC] ✅ Heading added');
  }

  // Get selected variant data
  function getSelectedVariantData() {
    // Try to get variant data from Shopify's variant JSON
    const variantJson = document.querySelector('[data-selected-variant]');
    if (variantJson) {
      try {
        const variant = JSON.parse(variantJson.textContent);
        if (variant && variant.price) {
          // Extract quantity from variant title (e.g. "40 Tablets")
          const quantityMatch = (variant.title || variant.option1 || '').match(/(\d+)/);
          const quantity = quantityMatch ? parseInt(quantityMatch[1], 10) : 1;
          
          return {
            quantity,
            price: variant.price / 100, // Shopify stores price in cents
            comparePrice: (variant.compare_at_price || variant.price) / 100,
            variantName: variant.title || variant.option1 || ''
          };
        }
      } catch (e) {
        console.log('[RC] Could not parse variant JSON:', e);
      }
    }

    // Fallback: get from variant picker
    const fieldset = document.querySelector('.product-form__input--pill');
    if (!fieldset) return null;
    
    const selectedInput = fieldset.querySelector('input[type="radio"]:checked');
    if (!selectedInput) return null;
    
    const label = fieldset.querySelector(`label[for="${selectedInput.id}"]`);
    if (!label) return null;
    
    // Get variant name from label text (e.g. "40 Tablets")
    const variantName = label.textContent?.trim() || '';
    
    // Extract quantity from name (e.g. 40 from "40 Tablets")
    const quantityMatch = variantName.match(/(\d+)/);
    const quantity = quantityMatch ? parseInt(quantityMatch[1], 10) : 1;
    
    // Get price from ReCharge widget's one-time option
    const widget = document.querySelector('recharge-subscription-widget');
    let price = 0;
    if (widget && widget.shadowRoot) {
      const oneTimePriceEl = widget.shadowRoot.querySelector('.rc-purchase-option__onetime .rc-price, .rc-selection__onetime .rc-price');
      if (oneTimePriceEl) {
        const priceText = oneTimePriceEl.textContent?.trim() || '$0';
        price = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
      }
    }
    
    return {
      quantity,
      price,
      comparePrice: price,
      variantName
    };
  }
  
  // Calculate unit price
  function calculateUnitPrice(totalPrice, quantity) {
    if (quantity <= 0) return 0;
    return totalPrice / quantity;
  }
  
  // Format price
  function formatUnitPrice(price, unitName = window.fabtabUnitLabel || 'Tablet') {
    return `$${price.toFixed(2)}/${unitName}`;
  }
  
  // Update unit price display
  function updateUnitPrices() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget || !widget.shadowRoot) return;
    
    const variantData = getSelectedVariantData();
    if (!variantData) return;
    
    const { quantity, price, comparePrice } = variantData;
    
    // Unit price for one-time (full price)
    const oneTimeUnitPrice = calculateUnitPrice(price, quantity);
    
    // Unit price for subscription (with ReCharge discount)
    // ReCharge shows discounted price in its widget, so we take it from there
    const subscriptionPriceEl = widget.shadowRoot.querySelector('.rc-purchase-option__subscription .rc-price:not(.strike-through):not(.text-muted)');
    let subscriptionPrice = price;
    if (subscriptionPriceEl) {
      const subscriptionPriceText = subscriptionPriceEl.textContent?.trim() || '';
      subscriptionPrice = parseFloat(subscriptionPriceText.replace(/[^0-9.]/g, '')) || price;
    }
    const subscriptionUnitPrice = calculateUnitPrice(subscriptionPrice, quantity);
    
    // Update text in elements
    const unitPriceElements = widget.shadowRoot.querySelectorAll('.rc-unit-price');
    unitPriceElements.forEach((el, index) => {
      // index 0 = subscription, index 1 = one-time
      const unitPrice = index === 0 ? subscriptionUnitPrice : oneTimeUnitPrice;
      el.textContent = formatUnitPrice(unitPrice);
    });
    
    console.log('[RC] ✅ Unit prices updated:', { subscriptionUnitPrice, oneTimeUnitPrice, quantity });
  }

  function addUnitPrices(shadowRoot) {
    if (!shadowRoot) return;
    
    const options = shadowRoot.querySelectorAll('.rc-purchase-option');
    let added = false;
    
    options.forEach((option, index) => {
      // Skip if already wrapped
      if (option.querySelector('.rc-prices-wrapper')) return;
      
      const prices = option.querySelector('.rc-purchase-option__prices');
      if (!prices) return;
      
      // Create wrapper
      const wrapper = document.createElement('div');
      wrapper.className = 'rc-prices-wrapper';
      
      // Wrap prices in wrapper
      prices.parentNode.insertBefore(wrapper, prices);
      wrapper.appendChild(prices);
      
      // Add unit price element (will be filled dynamically)
      const unitPrice = document.createElement('div');
      unitPrice.className = 'rc-unit-price';
      unitPrice.textContent = ''; // Will be filled by updateUnitPrices()
      wrapper.appendChild(unitPrice);
      added = true;
    });
    
    // Update prices only if we added new elements
    if (added) {
      // Small delay for DOM to update
      setTimeout(updateUnitPrices, 50);
      console.log('[RC] ✅ Unit prices added');
    }
  }
  
  // Listener for variant change via Shopify PubSub
  function setupVariantChangeListener() {
    // Avoid double subscription
    if (window.rcUnitPriceSubscribed) return;
    window.rcUnitPriceSubscribed = true;
    
    // Subscribe to Shopify PubSub variantChange event
    if (typeof subscribe === 'function') {
      subscribe('variant-change', (data) => {
        console.log('[RC] 🔄 Variant changed via PubSub:', data);
        // Minimal delay
        setTimeout(updateUnitPrices, 50);
        setTimeout(updateUnitPrices, 150);
        setTimeout(updateUnitPrices, 500);
      });
      console.log('[RC] ✅ Subscribed to variant-change event');
    } else {
      console.warn('[RC] ⚠️ PubSub subscribe not available');
    }
    
    // Also listen for clicks on variant picker radio buttons as fallback
    const variantPicker = document.querySelector('.product-form__input--pill, variant-selects');
    if (variantPicker) {
      variantPicker.addEventListener('change', (e) => {
        if (e.target.type === 'radio') {
          console.log('[RC] 🔄 Variant changed via radio change');
          setTimeout(updateUnitPrices, 100);
          setTimeout(updateUnitPrices, 300);
          setTimeout(updateUnitPrices, 600);
        }
      });
      
      variantPicker.addEventListener('click', (e) => {
        if (e.target.tagName === 'LABEL' || e.target.closest('label')) {
          console.log('[RC] 🔄 Variant label clicked');
          setTimeout(updateUnitPrices, 100);
          setTimeout(updateUnitPrices, 300);
          setTimeout(updateUnitPrices, 600);
        }
      });
      console.log('[RC] ✅ Added variant picker change listener');
    }
  }

  /**
   * Add "Today's Total" / "Recurring" summary block after the widget
   */
  function addPriceSummary() {
    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget) return;

    // Check if already exists
    if (document.querySelector('.rc-price-summary')) return;

    const summaryBlock = document.createElement('div');
    summaryBlock.className = 'rc-price-summary';
    summaryBlock.innerHTML = `
      <div class="rc-price-summary__row rc-price-summary__row--today">
        <p class="rc-price-summary__label">Today's Total</p>
        <p class="rc-price-summary__value" id="rc-today-total">$0.00</p>
      </div>
      <div class="rc-price-summary__row rc-price-summary__row--recurring">
        <p class="rc-price-summary__label">Recurring</p>
        <p class="rc-price-summary__value" id="rc-recurring-price">$0.00</p>
      </div>
    `;

    // Insert after widget
    widget.parentNode.insertBefore(summaryBlock, widget.nextSibling);
    
    // Initial price update with delay to allow widget to render prices
    setTimeout(updatePriceSummary, 100);
    setTimeout(updatePriceSummary, 500);

    // Listen for clicks on purchase options to detect subscription/one-time toggle
    setupPurchaseOptionListener(widget);

    // Listen for quantity selector changes so the total reflects how many are being added
    setupQuantityListener();
    setTimeout(setupQuantityListener, 500);
    setTimeout(setupQuantityListener, 1000);

    console.log('[RC] ✅ Price summary block added');
  }

  /**
   * Find the PDP's own quantity stepper. Scoped to the widget's <product-info>
   * ancestor rather than a bare document.querySelector('.quantity__input'),
   * because that class isn't unique to the PDP -- the cart drawer renders a
   * same-class quantity input per line item once anything is in the cart, and
   * an unscoped lookup can silently latch onto one of those instead once the
   * drawer has been opened, freezing "Today's Total" at a stale value.
   */
  function getPdpQuantityInput() {
    const widget = document.querySelector('recharge-subscription-widget');
    const scope = (widget && widget.closest('product-info')) || document;
    return scope.querySelector('.quantity__input');
  }

  /**
   * Read the quantity selector's current value (the -/+ stepper next to Add to Cart).
   * Defaults to 1 if it can't be found or is invalid.
   */
  function getSelectedQuantity() {
    const quantityInput = getPdpQuantityInput();
    const value = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    return Number.isFinite(value) && value > 0 ? value : 1;
  }

  /**
   * Re-run the price summary update whenever the quantity selector changes,
   * so "Today's Total" reflects the full amount being added to cart, not just
   * the price of a single unit.
   */
  function setupQuantityListener() {
    const quantityInput = getPdpQuantityInput();
    if (!quantityInput || quantityInput.dataset.rcQuantityListenerSetup === 'true') return;
    quantityInput.dataset.rcQuantityListenerSetup = 'true';

    quantityInput.addEventListener('input', updatePriceSummary);
    quantityInput.addEventListener('change', updatePriceSummary);

    console.log('[RC] ✅ Quantity selector listener added');
  }

  /**
   * Helper to find element in shadow DOM tree (including nested shadow roots)
   */
  function queryShadow(root, selector) {
    if (!root) return null;
    
    // Try direct query first
    let result = root.querySelector(selector);
    if (result) return result;
    
    // Search in nested shadow roots
    const allElements = root.querySelectorAll('*');
    for (const el of allElements) {
      if (el.shadowRoot) {
        result = queryShadow(el.shadowRoot, selector);
        if (result) return result;
      }
    }
    return null;
  }

  /**
   * Setup listener for purchase option changes (subscription/one-time toggle)
   */
  function setupPurchaseOptionListener(widget) {
    if (!widget.shadowRoot) return;

    // Find rc-purchase-options component (may have its own shadow DOM)
    const findPurchaseOptions = () => {
      const rcPurchaseOptions = widget.shadowRoot.querySelector('rc-purchase-options');
      if (rcPurchaseOptions && rcPurchaseOptions.shadowRoot) {
        return rcPurchaseOptions.shadowRoot;
      }
      return widget.shadowRoot;
    };

    // Function to setup observers on purchase options
    const setupObservers = () => {
      const optionsRoot = findPurchaseOptions();
      const subOption = optionsRoot.querySelector('.rc-purchase-option__subscription');
      const oneTimeOption = optionsRoot.querySelector('.rc-purchase-option__onetime');

      console.log('[RC] Found subscription option:', !!subOption);
      console.log('[RC] Found one-time option:', !!oneTimeOption);

      // Watch for attribute changes on purchase options
      const purchaseOptionsObserver = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes') {
            console.log('[RC] Purchase option attribute changed:', mutation.attributeName);
            setTimeout(updatePriceSummary, 50);
            setTimeout(updatePriceSummary, 200);
            break;
          }
        }
      });

      if (subOption) {
        purchaseOptionsObserver.observe(subOption, { attributes: true, attributeFilter: ['rc-selected', 'rc-not-selected', 'class'] });
        console.log('[RC] Observing subscription option');
      }
      if (oneTimeOption) {
        purchaseOptionsObserver.observe(oneTimeOption, { attributes: true, attributeFilter: ['rc-selected', 'rc-not-selected', 'class'] });
        console.log('[RC] Observing one-time option');
      }

      // Also observe the rc-purchase-options shadow root if it exists
      const rcPurchaseOptions = widget.shadowRoot.querySelector('rc-purchase-options');
      if (rcPurchaseOptions && rcPurchaseOptions.shadowRoot) {
        const innerObserver = new MutationObserver(() => {
          console.log('[RC] rc-purchase-options inner mutation');
          setTimeout(updatePriceSummary, 50);
          setTimeout(updatePriceSummary, 200);
        });
        innerObserver.observe(rcPurchaseOptions.shadowRoot, { 
          childList: true, 
          subtree: true, 
          attributes: true 
        });
        console.log('[RC] Observing rc-purchase-options shadow root');
      }
    };

    // Setup observers initially and after delays
    setupObservers();
    setTimeout(setupObservers, 500);
    setTimeout(setupObservers, 1000);
    setTimeout(setupObservers, 2000);

    // Watch entire widget shadow DOM for any changes
    const widgetObserver = new MutationObserver(() => {
      setTimeout(updatePriceSummary, 100);
    });

    widgetObserver.observe(widget.shadowRoot, { 
      childList: true, 
      subtree: true, 
      attributes: true
    });

    // Click listener on widget shadow root
    widget.shadowRoot.addEventListener('click', (e) => {
      console.log('[RC] Click in widget shadow root:', e.target.tagName, e.target.className);
      setTimeout(updatePriceSummary, 100);
      setTimeout(updatePriceSummary, 300);
      setTimeout(updatePriceSummary, 500);
    });

    // Also add click listener to rc-purchase-options if it has shadow root
    const rcPurchaseOptions = widget.shadowRoot.querySelector('rc-purchase-options');
    if (rcPurchaseOptions && rcPurchaseOptions.shadowRoot) {
      rcPurchaseOptions.shadowRoot.addEventListener('click', (e) => {
        console.log('[RC] Click in rc-purchase-options shadow root:', e.target.tagName);
        setTimeout(updatePriceSummary, 100);
        setTimeout(updatePriceSummary, 300);
        setTimeout(updatePriceSummary, 500);
      });
    }

    console.log('[RC] ✅ Purchase option change listener added');
  }

  /**
   * Find purchase options root (handles nested shadow DOM)
   */
  function getPurchaseOptionsRoot(widget) {
    const rcPurchaseOptions = widget.shadowRoot.querySelector('rc-purchase-options');
    if (rcPurchaseOptions && rcPurchaseOptions.shadowRoot) {
      return rcPurchaseOptions.shadowRoot;
    }
    return widget.shadowRoot;
  }

  /**
   * Tooltip configuration for learn more icon
   */
  const TOOLTIP_CONTENT = {
    title: 'You <strong>save 20%</strong> off your first order, and 10% off all following autoship orders.',
    subtitle: 'Change or cancel autoship at any time.'
  };

  const TOOLTIP_STYLES = `
    /* Tooltip styles for rc-learn-more */
    .rc-tooltip-wrapper {
      position: relative;
      display: inline-flex;
      align-items: center;
    }
    
    .rc-tooltip {
      position: absolute;
      bottom: calc(80% + 10px);
      left: calc(30% + 8px);
      transform: none;
      background-color: #FEF7E6;
      border: 1px solid #E5D9C3;
      border-radius: 8px;
      padding: 12px 16px;
      min-width: 260px;
      max-width: 300px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      z-index: 1000;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.2s ease, visibility 0.2s ease;
      pointer-events: none;
    }
    
    .rc-tooltip::before {
      content: '';
      position: absolute;
      bottom: -8px;
      left: 16px;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-top: 8px solid #E5D9C3;
    }
    
    .rc-tooltip::after {
      content: '';
      position: absolute;
      bottom: -6px;
      left: 17px;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-top: 7px solid #FEF7E6;
    }

    @media screen and (min-width: 350px) and (max-width: 699.99px) {
	    .rc-tooltip {
        transform: translateX(-60%);
      }
      .rc-tooltip::before {
        left:calc(60% - 13px);
      }
      .rc-tooltip::after {
        left:calc(60% - 13px);
      }
    }

    @media screen and (max-width: 349.99px) {
      .rc-tooltip {
        transform: translateX(-55%);
      }
      .rc-tooltip::before {
        left:calc(55% - 13px);
      }
      .rc-tooltip::after {
        left:calc(55% - 13px);
      }
    }
    
    .rc-tooltip--visible {
      opacity: 1;
      visibility: visible;
      pointer-events: auto;
    }
    
    .rc-tooltip__text {
      font-family: 'Inter', sans-serif !important;
      font-size: 13px;
      line-height: 1.5;
      color: #4d6e89;
      margin: 0;
    }
    
    .rc-tooltip__text strong {
      font-weight: 600;
      color: #003057;
    }
    
    .rc-tooltip__text--subtitle {
      margin-top: 8px;
      font-size: 12px;
    }
    
    /* Hide original modal/popup */
    rc-learn-more .rc-learn-more__modal,
    rc-learn-more .rc-modal,
    .rc-learn-more__modal,
    .rc-modal {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }
    
    /* Style the trigger icon */
    rc-learn-more,
    .rc-learn-more__trigger {
      cursor: pointer;
    }
  `;

  /**
   * Setup tooltip for learn more icon (replaces popup)
   */
  function setupLearnMoreTooltip(shadowRoot) {
    if (!shadowRoot) return;

    // Inject tooltip styles
    injectStyles(shadowRoot, 'rc-tooltip-styles', TOOLTIP_STYLES);

    // Find rc-learn-more element (may be in nested shadow DOM)
    const findLearnMore = () => {
      // Direct search
      let learnMore = shadowRoot.querySelector('rc-learn-more');
      if (learnMore) return learnMore;

      // Search in rc-purchase-options shadow DOM
      const rcPurchaseOptions = shadowRoot.querySelector('rc-purchase-options');
      if (rcPurchaseOptions && rcPurchaseOptions.shadowRoot) {
        learnMore = rcPurchaseOptions.shadowRoot.querySelector('rc-learn-more');
        if (learnMore) return learnMore;
      }

      return null;
    };

    const learnMore = findLearnMore();
    if (!learnMore) {
      console.log('[RC] rc-learn-more not found yet');
      return;
    }

    // Check if tooltip already added
    if (learnMore.dataset.tooltipSetup === 'true') return;
    learnMore.dataset.tooltipSetup = 'true';

    // Create tooltip element
    const tooltip = document.createElement('div');
    tooltip.className = 'rc-tooltip';
    tooltip.innerHTML = `
      <p class="rc-tooltip__text">${TOOLTIP_CONTENT.title}</p>
      <p class="rc-tooltip__text rc-tooltip__text--subtitle">${TOOLTIP_CONTENT.subtitle}</p>
    `;

    // Wrap learn-more in a wrapper for positioning
    const wrapper = document.createElement('div');
    wrapper.className = 'rc-tooltip-wrapper';
    learnMore.parentNode.insertBefore(wrapper, learnMore);
    wrapper.appendChild(learnMore);
    wrapper.appendChild(tooltip);

    // Show tooltip on hover
    wrapper.addEventListener('mouseenter', () => {
      tooltip.classList.add('rc-tooltip--visible');
    });

    wrapper.addEventListener('mouseleave', () => {
      tooltip.classList.remove('rc-tooltip--visible');
    });

    // Prevent default click behavior (modal opening)
    learnMore.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }, true);

    // Also prevent click on trigger inside shadow DOM if exists
    if (learnMore.shadowRoot) {
      const trigger = learnMore.shadowRoot.querySelector('.rc-learn-more__trigger');
      if (trigger) {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        }, true);
      }
      
      // Inject styles into rc-learn-more shadow root to hide modal
      injectStyles(learnMore.shadowRoot, 'rc-learn-more-styles', `
        .rc-learn-more__modal,
        .rc-modal,
        [class*="modal"] {
          display: none !important;
          visibility: hidden !important;
          opacity: 0 !important;
          pointer-events: none !important;
          position: absolute !important;
          left: -9999px !important;
        }
      `);
    }

    console.log('[RC] ✅ Learn more tooltip setup complete');
  }

  /**
   * Update prices in the summary block
   */
  function updatePriceSummary() {
    const todayEl = document.getElementById('rc-today-total');
    const recurringEl = document.getElementById('rc-recurring-price');
    const recurringRow = document.querySelector('.rc-price-summary__row--recurring');
    if (!todayEl || !recurringEl) return;

    const widget = document.querySelector('recharge-subscription-widget');
    if (!widget || !widget.shadowRoot) return;

    // Get the correct root for purchase options (may be nested shadow DOM)
    const optionsRoot = getPurchaseOptionsRoot(widget);

    // Get subscription option
    const subOption = optionsRoot.querySelector('.rc-purchase-option__subscription');
    
    // Get one-time option - correct selector is rc-selection__onetime
    const oneTimeOption = optionsRoot.querySelector('.rc-selection__onetime');
    
    console.log('[RC] updatePriceSummary - subOption:', !!subOption, 'oneTimeOption:', !!oneTimeOption);
    
    if (!subOption) {
      console.log('[RC] No subscription option found');
      return;
    }

    // Check which option is selected
    const isSubscriptionSelected = subOption.hasAttribute('rc-selected');
    const isOneTimeSelected = oneTimeOption && oneTimeOption.hasAttribute('rc-selected');
    
    console.log('[RC] isSubscriptionSelected:', isSubscriptionSelected, 'isOneTimeSelected:', isOneTimeSelected);

    // Get the base/regular price (one-time price or original price)
    let regularPrice = null;
    
    // Try to get price from one-time option first
    if (oneTimeOption) {
      const oneTimePriceEl = oneTimeOption.querySelector('[class*="price"]');
      if (oneTimePriceEl) {
        const match = oneTimePriceEl.textContent.trim().match(/\$[\d,.]+/);
        if (match) regularPrice = match[0];
      }
    }
    
    // If no one-time price, get from original price in subscription
    if (!regularPrice) {
      const originalPriceEl = subOption.querySelector('.rc-purchase-option__original-price, [class*="original-price"]');
      if (originalPriceEl) {
        const match = originalPriceEl.textContent.trim().match(/\$[\d,.]+/);
        if (match) regularPrice = match[0];
      }
    }
    
    // Get subscription discounted price
    let subscriptionPrice = null;
    const discountPriceEl = subOption.querySelector('.rc-purchase-option__discount-price, [class*="discount-price"]');
    if (discountPriceEl) {
      const match = discountPriceEl.textContent.trim().match(/\$[\d,.]+/);
      if (match) subscriptionPrice = match[0];
    }
    
    // If no discount price element, calculate 20% off from regular price
    if (!subscriptionPrice && regularPrice) {
      const priceNum = parseFloat(regularPrice.replace(/[$,]/g, ''));
      subscriptionPrice = '$' + (priceNum * 0.8).toFixed(2);
    }
    
    console.log('[RC] regularPrice:', regularPrice, 'subscriptionPrice:', subscriptionPrice);

    const quantity = getSelectedQuantity();

    // Update display based on selection
    if (isSubscriptionSelected && subscriptionPrice) {
      // Subscription selected - show discounted price (20% off)
      const subscriptionNum = parseFloat(subscriptionPrice.replace(/[$,]/g, ''));

      // Recurring is 10% off regular price (not 20%), so it's higher than Today's Total
      // Calculate: regularPrice * 0.9
      let recurringNum;
      if (regularPrice) {
        const regularNum = parseFloat(regularPrice.replace(/[$,]/g, ''));
        recurringNum = regularNum * 0.9;
      } else {
        // Fallback: Today's Total has 20% discount, Recurring has 10% discount
        // So Recurring = Today's Total / 0.8 * 0.9
        recurringNum = (subscriptionNum / 0.8) * 0.9;
      }

      todayEl.textContent = '$' + (subscriptionNum * quantity).toFixed(2);
      recurringEl.textContent = '$' + (recurringNum * quantity).toFixed(2);

      if (recurringRow) recurringRow.style.display = 'flex';
      console.log('[RC] ✅ Updated to SUBSCRIPTION:', todayEl.textContent, '| Recurring:', recurringEl.textContent, '| Qty:', quantity);
    } else if (regularPrice) {
      // One-time selected - show regular price
      const regularNum = parseFloat(regularPrice.replace(/[$,]/g, ''));
      todayEl.textContent = '$' + (regularNum * quantity).toFixed(2);

      // Hide recurring row for one-time purchase
      if (recurringRow) recurringRow.style.display = 'none';
      console.log('[RC] ✅ Updated to ONE-TIME:', todayEl.textContent, '| Qty:', quantity);
    } else {
      console.log('[RC] ⚠️ Could not determine prices');
    }
  }

  // Track which widgets have been initialized
  const initializedWidgets = new WeakSet();

  function initWidget(widget) {
    if (!widget || !widget.shadowRoot || initializedWidgets.has(widget)) return;
    initializedWidgets.add(widget);

    // Add heading before widget
    addHeading();

    // Inject styles to main shadow root
    injectStyles(widget.shadowRoot, 'rc-custom-styles', STYLES);

    // Replace radio icons with custom checkmarks
    replaceRadioIcons(widget.shadowRoot);

    // Preserve benefits content
    preserveBenefitsContent(widget.shadowRoot);

    // Add unit prices
    addUnitPrices(widget.shadowRoot);

    // Add price summary block
    addPriceSummary();

    // Setup listener for variant changes
    setupVariantChangeListener();

    // Setup tooltip for learn more icon
    setupLearnMoreTooltip(widget.shadowRoot);

    // Find and inject styles to nested rc-benefits shadow root
    const rcBenefits = widget.shadowRoot.querySelector('#rc-benefits');
    if (rcBenefits && rcBenefits.shadowRoot) {
      injectStyles(rcBenefits.shadowRoot, 'rc-benefits-custom-styles', BENEFITS_STYLES);
    }

    // Watch for changes and re-inject if needed
    const observer = new MutationObserver(() => {
      injectStyles(widget.shadowRoot, 'rc-custom-styles', STYLES);
      replaceRadioIcons(widget.shadowRoot);
      preserveBenefitsContent(widget.shadowRoot);
      addUnitPrices(widget.shadowRoot);
      updatePriceSummary();
      setupLearnMoreTooltip(widget.shadowRoot);

      const rcBenefits = widget.shadowRoot.querySelector('#rc-benefits');
      if (rcBenefits && rcBenefits.shadowRoot) {
        injectStyles(rcBenefits.shadowRoot, 'rc-benefits-custom-styles', BENEFITS_STYLES);
      }
    });

    observer.observe(widget.shadowRoot, { childList: true, subtree: true });
  }

  function initAllWidgets() {
    document.querySelectorAll('recharge-subscription-widget').forEach(widget => {
      if (widget.shadowRoot) {
        initWidget(widget);
      } else {
        // Widget exists but shadow root not ready yet, wait for it
        const waitForShadow = () => {
          if (widget.shadowRoot) {
            initWidget(widget);
          } else {
            setTimeout(waitForShadow, 300);
          }
        };
        setTimeout(waitForShadow, 300);
      }
    });
  }

  function init() {
    initAllWidgets();

    // Watch for new widgets added to the DOM (e.g. quick-add modals)
    const bodyObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== 1) continue;
          // Check if the added node is or contains a recharge widget
          if (node.tagName === 'RECHARGE-SUBSCRIPTION-WIDGET') {
            const waitForShadow = () => {
              if (node.shadowRoot) {
                initWidget(node);
              } else {
                setTimeout(waitForShadow, 300);
              }
            };
            setTimeout(waitForShadow, 300);
          } else if (node.querySelector) {
            const widgets = node.querySelectorAll('recharge-subscription-widget');
            widgets.forEach(w => {
              const waitForShadow = () => {
                if (w.shadowRoot) {
                  initWidget(w);
                } else {
                  setTimeout(waitForShadow, 300);
                }
              };
              setTimeout(waitForShadow, 300);
            });
          }
        }
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
